import React from 'react';
import { Currency } from '../../../common/format';

interface CurrencySwitchProps {
  value: Currency;
  onChange: (currency: Currency) => void;
}

export function CurrencySwitch({ value, onChange }: CurrencySwitchProps) {
  return (
    <div className="btn-group btn-group-sm" role="group" aria-label="Cambiar moneda">
      <button
        type="button"
        className={`btn ${value === 'UF' ? 'btn-primary' : 'btn-outline-primary'}`}
        onClick={() => onChange('UF')}
      >
        UF
      </button>
      <button
        type="button"
        className={`btn ${value === 'CLP' ? 'btn-primary' : 'btn-outline-primary'}`}
        onClick={() => onChange('CLP')}
      >
        CLP
      </button>
    </div>
  );
}
